import React from "react";
import {Sparkles, TrendingUp, Shuffle, Clock, Video, Leaf} from "lucide-react";
import { ColorTheme } from "../../../themes/colors";
import { getFeaturesStyles } from "../../../themes/styles/features";
import { getCommonStyles } from "../../../themes/styles/common";
import FeatureCard from "./FeatureCard";
import Reveal from "../common/Reveal";
import { Feature } from "../../../types";
import { useLanguage } from "../../../i18n/LanguageContext";

interface FeaturesSectionProps {
    theme: ColorTheme;
    isMobile?: boolean;
}

const featureIcons = [
    <Leaf size={26} />,
    <Sparkles size={26} />,
    <TrendingUp size={26} />,
    <Shuffle size={26} />,
    <Clock size={26} />,
    <Video size={26} />,
];

const FeaturesSection: React.FC<FeaturesSectionProps> = ({ theme, isMobile = false }) => {
    const featuresStyles = getFeaturesStyles(theme);
    const commonStyles = getCommonStyles(theme);
    const { t } = useLanguage();

    const features: Feature[] = t.features.items.map((item, i) => ({
        icon: featureIcons[i],
        title: item.title,
        description: item.description,
    }));

    return (
        <section
            id="features"
            style={{
                ...featuresStyles.features,
                ...(isMobile ? featuresStyles.mobileFeatures : {}),
            }}
        >
            <div style={featuresStyles.featuresContainer}>
                <Reveal>
                    <h2 style={commonStyles.sectionTitle}>{t.features.sectionTitle}</h2>
                    <p style={commonStyles.sectionSubtitle}>
                        {t.features.sectionSubtitle}
                    </p>
                </Reveal>

                <div
                    style={{
                        ...featuresStyles.featuresGrid,
                        ...(isMobile ? featuresStyles.mobileFeaturesGrid : {}),
                    }}
                >
                    {features.map((feature, index) => (
                        <Reveal key={index} delay={isMobile ? 0 : (index % 3) * 90} style={{ height: "100%" }}>
                            <FeatureCard
                                feature={feature}
                                theme={theme}
                                isMobile={isMobile}
                                index={index}
                            />
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;
